import React from 'react';
import '../AboutMe/AboutMe.css';
import Position from '../Position/Position';
import '../AboutMe/AboutmeResponsive.css';

function AboutMe() {
  return (
    <div className='AboutMe_Section'>
      <div className="About_Heading">
        <h2>Hi, I’m Ashly. Nice to meet you.</h2>
      </div>
      <div className="About_Para">
        <p>Starting my journey from 2 years back, I serve as a dedicated SEO Analyst. I learn new tips and tricks everytime I work and it shows in your website rankings. Also my passion moulded myself into a self made Front End Developer. So that, I assure to hand your dream website with excellent SEO and Design. <br></br> Let's create something unique.</p>
      </div>
    </div>
  );
}

export default AboutMe;
